//Quick View

$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });
});
function quickView() {
  $(document).on("click", ".quick-view", function () {
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    var product_handle = $(this).data('handle');
    $('#quick-view').addClass(product_handle);
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var title = product.title;
      var type = product.type;
      var vendor = product.vendor;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var url = '/products/' + product_handle;
      $('.qv-product-title').text(title);
      $('.qv-product-vendor').text(vendor);
      var shortDesc = jQuery.trim(desc).substring(0, 250).split(" ").slice(0, -1).join(" ") + "...";
      $('.qv-product-description').html(shortDesc);
      $('.view-product').attr('href', url);
      var imageCount = $(images).length;
      $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div class="sliderImages"><img  src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
          $('.qv-product-images').slick({
            'dots': true,
            'arrows': true,
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1');
          $("#quick-view").find(".slick-list").css("opacity","0");
        } else {
          var image_embed = '<div class="sliderImages"><img  src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
          
        }
      });
      if(type == "Unify"){
        $('.qv-add-to-cart').hide();
        $(".qv-product-price").hide();
        $(".qv-product-original-price").addClass("d-none");
        var storeLocatorButton = '<input type="submit" class="qv-store-locator" value="Store Locator">';
        $(".holder").append(storeLocatorButton);
      }
      $(".qv-store-locator").click(function(){
        location.href = 'https://barcomade.com/apps/store-locator';
      });
      var allVariantsSelect = '<select class="allVariants_Selector"></select>';
      $('.qv-product-options').prepend(allVariantsSelect);
       $(variants).each(function(i, demo){
         var featuredImage = demo.featured_image;
         if(featuredImage != null){
           var imgOption = demo.featured_image.src;
         }
         var allVariantsOption = '<option varID="'+demo.id+'" compare_price="'+demo.compare_at_price+'" price="'+demo.price+'" value="'+demo.option1+demo.option2+demo.option3+'" title="'+demo.title+'" available="'+demo.available+'" inventory="'+demo.inventory_management+'" size="'+demo.option1+'" color="'+demo.option2+'" fit="'+demo.option3+'" imgSrc="'+imgOption+'"></option>';
         $(".allVariants_Selector").append(allVariantsOption);
        });
     
      $(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        if(opt == "Color"){
           $('.qv-product-options').append('<div id="onlyColor" class="option-selection-' + opt.toLowerCase() + ' repeatedClass"><span class="option">' + opt + ':</span><span class="selectedColorDisplay"></span><select class="customSelect hiddenSelect_'+opt+' option-' + opt + '"></select><div class="onlyColor option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
        }
        else{
           $('.qv-product-options').append('<div id="only'+opt+'" class="option-selection-' + opt.toLowerCase() + ' repeatedClass"><span class="option">' + opt + '</span><select class="customSelect hiddenSelect_'+opt+' option-' + i + '"></select><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
        }
        
        $(option.values).each(function (i, value) {
          if(opt == "Color"){
           return false;
          }
            else if(opt == "Fit"){
                $('.hiddenSelect_'+opt+'').append('<option value="' + value + '">' + value + '</option>');
            $('.option.' + opt.toLowerCase()).append('<div class="optionRadios" id="Fit_'+value+'"><input val="'+value+'" type="radio" name="'+opt+'" id="option_radio_'+value.toLowerCase()+'"><label for=option_radio_'+value.toLowerCase()+'">'+value+'</label></div>');
            }
          else{
            return false;
          }
        });
      });
        const unavailableVariants = []; 
        for (let j = 0; j < product.variants.length; j++) {
          const variant = product.variants[j];
          if (variant.available) {
            unavailableVariants.push(variant.option2);
          }
        }
         var uniqueCOlor = unavailableVariants.filter(function(itm, i, unavailableVariants) {
            return i == unavailableVariants.indexOf(itm);
        });
        for (var clr=0; clr<uniqueCOlor.length; clr++) {
         var value = uniqueCOlor[clr];
           var getColorVal = value.replace(/ /g,"-");
            getColorVal = getColorVal.replace(/\//g,"-");
            $('#onlyColor select').append('<option value="' + value + '">' + value + '</option>');
            $('#onlyColor .onlyColor').append('<div class="optionRadios"><span data-tooltip="'+value+'">'+value+'</span><input val="'+value+'" type="radio" name="Color" id="option_radio_'+value.toLowerCase()+'"><label data-colorname="'+getColorVal.toLowerCase()+'" swatchName="'+getColorVal+'" for=option_radio_'+value.toLowerCase()+'"></label></div>');
       }

        const unavailableVariantsSize = [];
        for (let t = 0; t < product.variants.length; t++) {
          const variant = product.variants[t];
          if (variant.available) {
            unavailableVariantsSize.push(variant.option1);
          }
        }
         var uniqueSize = unavailableVariantsSize.filter(function(itm, i, unavailableVariantsSize) {
            return i == unavailableVariantsSize.indexOf(itm);
        });
        for (var ss=0; ss<uniqueSize.length; ss++) {
           var valueSize = uniqueSize[ss];
           var getColorVal = valueSize.replace(/ /,"-");
            getColorVal = getColorVal.replace(/\//g,"-");
            $('#onlySize select').append('<option value="' + valueSize + '">' + valueSize + '</option>');
            $('#onlySize .size').append('<div class="optionRadios" id="Size_'+valueSize+'"><span data-tooltip="'+valueSize+'">'+valueSize+'</span><input val="'+valueSize+'" type="radio" name="Color" id="option_radio_'+valueSize.toLowerCase()+'"><label data-colorname="'+getColorVal.toLowerCase()+'" swatchName="'+getColorVal+'" for=option_radio_'+valueSize.toLowerCase()+'">'+valueSize +'</label></div>');
       }
      
      $(".allVariants_Selector").children("option[available=false]").each(function(){
        var el = $(this);
        var size = $(this).attr("size");
        var color = $(this).attr("color");
        var fit = $(this).attr("fit");
        $(".allVariants_Selector").children("option[available=true]").each(function(){
          var newSize = $(this).attr("size");
          var newColor = $(this).attr("color");
          var newFit = $(this).attr("fit");
          if(size == newSize){
            return false;
          }
          else{
              $(el).addClass("disable");
          }
        });
      });
      $(".optionRadios").click(function(){
        var elem = $(this);
        $(elem).parent(".option").find("input[checked=checked]").removeAttr("checked");
        $(elem).parent(".option").find("label").removeClass("active");
        $(elem).children("input").attr("checked","checked");
        var getVal = $(elem).children("input").attr("val");
        $(elem).parent(".option").siblings("select").val(getVal);
        $(elem).parent(".option").siblings("select").trigger("change");
        $(elem).children("label").addClass("active");
        var sizeSelected = $(".hiddenSelect_Size").val();
        var colorSelected = $(".hiddenSelect_Color").val();
        var fitSelected = $(".hiddenSelect_Fit").val();
        $(".allVariants_Selector").val(sizeSelected+colorSelected+fitSelected);
        $(".allVariants_Selector").trigger("change");
        if($(elem).parent(".option").hasClass("size")){
          if($(elem).hasClass("not_avail")){
            $(".qv-add-button").addClass("unav");
            $(".qv-add-button").val("currently unavailable");
          }
          else {
            $("#onlySize").find(".sizeMsg").remove();
            $(".qv-add-button").removeClass("unav");
            $(".qv-add-button").val("add to cart");
            filterVariants(sizeSelected, colorSelected, fitSelected);
          }
        }
        if($(elem).parent(".option").hasClass("color")){
          $("#quick-view").find(".slick-list").css("opacity","0");
          var onlyColor = $(".hiddenSelect_Color").val();
          filterVariantsOnColor(onlyColor);
          $(".selectedColorDisplay").html(onlyColor);
          setTimeout(function(){
            $("#quick-view").find(".slick-list").css("opacity","1");
            },700);
           var variant = $(".allVariants_Selector option:selected").attr("varid");
      var _href = $("#quick-view .view-product").attr("href");
       _href = _href.split('?')[0] 
      $("#quick-view .view-product").attr("href", _href + '?variant=' + variant);
      
        }
        setTimeout(function(){
        var selectedPrice = $(".allVariants_Selector option:selected").attr("price");
        var selectedComparePrice = $(".allVariants_Selector option:selected").attr("compare_price");
        selectedPrice = parseFloat(selectedPrice / 100).toFixed(2);
        $(".qv-product-price").html("$" + selectedPrice);
        if(selectedComparePrice != "null"){
          selectedComparePrice = parseFloat(selectedComparePrice / 100).toFixed(2);
          $(".qv-product-original-price").html("$" + selectedComparePrice);
          $(".qv-product-original-price").show();
        }
        else{
          $(".qv-product-original-price").hide();
        }
          },1500);

         
        
      });
      $(product.variants).each(function (i, v) {
        if (v.inventory_quantity == 0) {
        //  $('.qv-add-button').prop('disabled', true).val('Sold Out');
          $('.qv-add-to-cart').hide();
         // $('.qv-product-price').text('Sold Out').show();
          return true
        } else {
          $('select.option-0').val(v.option1);
          $('select.option-1').val(v.option2);
          $('select.option-2').val(v.option3);
          return false
        }
      });
    });

    $(document).on("change", "#quick-view select", function () {
      var selectedOptions = '';
      $('.repeatedClass').each(function (i) {
        var elem = $(this).children("select");
        if (selectedOptions == '') {
          selectedOptions = $(elem).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(elem).val();
        }
      });
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var v_qty = v.inventory_quantity;
            var v_inv = v.inventory_management;
          //  $('.qv-product-price').text('$' + price);
           // $('.qv-product-original-price').text('$' + original_price);
            
          }
        });
      });
    });
    $.fancybox({
      href: '#quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openSpeed: 500,
      closeSpeed: 1000,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        var product_handle = $('#quick-view').attr('class');
        $(document).on("click", ".qv-add-button", function (event) {
           $("#onlySize").remove(".sizeMsg");
          var checkSize = $("#onlySize").find(".active");
          if($(checkSize).length > 0){
          var element = $(this);
          $(element).prop('disabled', true);
           event.preventDefault();
          var qty = $('.qv-quantity').val();
          var var_id = $(".allVariants_Selector").children("option:selected").attr("varid");
            var formOBJ = {
              id: var_id
            };
            $.ajax({
    		type: "POST",
    		url: "/cart/add.js",
    		cache:false,
    		data:formOBJ,
    		dataType: "json",
    		success: function (data) {
                 $(".fancybox-close").trigger("click");
                if ("redirect" == theme.settings.afterAddition) return (window.location = "/cart"), !1;
               theme.MiniCart.update()
                    .promise()
                    .done();
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log("error");
                console.log(xhr.status);
                console.log(thrownError);
            }
          });
          }
          else{
             if($("#onlySize").find(".sizeMsg").length == 0)
            $("#onlySize").children("span.option").append("<span class='sizeMsg' style='color:red; margin-left:5px; text-transform:initial'> Please select a size</span>");
            return false;
          }
        });
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
         // $(".option-0 .optionRadios:first").trigger("click");
           filterUnavailable();
          var selectedColor = $("#boost-pfs-filter-tree2-pf-opt-color").find(".boost-pfs-filter-option-item-list").children("li.selected").find(".boost-pfs-filter-option-value").html();
          if(selectedColor == undefined){
              $(".option-1 .optionRadios:first").trigger("click");
            }
          else{
             selectedColorFilter();
          }
        });
        
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
      }
    });
  });
};



function filterVariants(size, color, fit){
 
       $(".option-2 .optionRadios").removeClass("available");
    $(".option-2 .optionRadios").removeClass("unavailable");
  var getFits = [];
  $(".allVariants_Selector option[available=true]").each(function(){
    var elem = $(this);
    
      var globalSize = $(elem).attr("size");
    var globalColor = $(elem).attr("color");
    var globalFit = $(elem).attr("fit");
    if(globalColor == color){
      if(globalSize == size){
        getFits.push(globalFit);
      }
    }
  });
  for(var i=0;i<getFits.length;i++){
       $(".option-2 .optionRadios").each(function(){
        var elem = $(this);
        var elemFit = $(this).find("input").attr("val");
          if(getFits[i] == elemFit){
            $(elem).addClass("available");
          }
        if(!$(elem).hasClass("available")){
          $(elem).addClass("unavailable");
        }
      });
    }
  $(".option-2 .optionRadios.available").removeClass("unavailable");
  $(".option-2").children(".available:first").trigger("click");
}

function filterVariantsOnColor(color){
      var imgSrc = ""; 
  var getSizeToHide = [];
      $(".allVariants_Selector option").each(function(){
        var stock = $(this).attr("available");
        var getSize = $(this).attr("size");
        var getColor = $(this).attr("color");
        if(color == getColor){
          if(stock == "false"){
            getSizeToHide.push(getSize);
          }
        }
     });

    $(".option-0 .optionRadios").removeClass("not_avail");
  
     var sortSizes = getSizeToHide.filter(function(itm, i, getSizeToHide) {
         return i == getSizeToHide.indexOf(itm);
     });

     for(var i=0;i<sortSizes.length;i++){
       $("#Size_"+sortSizes[i]).addClass("not_avail");
     }
$(".option-0").children(".optionRadios").find("input[checked=checked]").trigger("click");
   var selectedSize = $(".option-0").children(".optionRadios").find("input:checked");  
  if($(selectedSize).parent(".optionRadios").is(":hidden")){
    $(selectedSize).parents(".option-0").children(".optionRadios:visible:first").trigger("click");
  }
  
  $(".allVariants_Selector option").each(function(){
     var elemImg = $(this);
        var imgColor = $(elemImg).attr("color");
        if(color == imgColor){
          imgSrc = $(elemImg).attr("imgsrc");
          if(imgSrc != "undefined"){
            return false;
          }
        }
  });
  
     imgSrc = imgSrc.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
      imgSrc = imgSrc.replace("https:","");
     $(".qv-product-images").find(".slick-slide").not(".slick-cloned").each(function(){
      var el = $(this);
      var getimgsrc = $(this).children("img").attr("src");
      if(imgSrc == getimgsrc){
        var getSliderid = $(el).attr("aria-describedby");
        $("#"+ getSliderid).trigger("click");
        return false;
      }
       else if(imgSrc == "undefined"){
         $(".slick-dots li:first").children("button").trigger("click");
       }
    });
}

function filterUnavailable(){
 var sizeArrayNew = [];
  var colorArray = [];
  var fitArray = [];
  $(".allVariants_Selector").children("option[available=false]").each(function(){
      var size = $(this).attr("size");
      var color = $(this).attr("color");
      var fit = $(this).attr("fit");
      $(sizeArrayNew).push(size);
      $(colorArray).push(color);
      $(fitArray).push(fit);
  });
   for(var i=0;i<colorArray.length;i++){
     $(".allVariants_Selector option[available=true]").each(function(){
       var elem = $(this);
       var getSize = $(this).attr("size");
       var getColor = $(this).attr("color");
       var getFit = $(this).attr("fit");
       if(colorArray[i] != getColor){
         $(elem).addClass("disabled");
         return false;
       }
     });
   }
}

function selectedColorFilter(){
  var selectedColorNew = $("#boost-pfs-filter-tree2-pf-opt-color").find(".boost-pfs-filter-option-item-list").children("li.selected").find(".boost-pfs-filter-option-value").html();
  if(selectedColorNew != "undefined"){
  selectedColorNew = selectedColorNew.replace(" ","-");
    setTimeout(function(){
      $(".optionRadios label[swatchName="+selectedColorNew+"]").trigger("click");
    },500);
  }
}










